export const Laterality = {
	Left: 'left',
	Right: 'right',
	NotApplicable: 'none',
}

export const LinkedElementType = {
	Appointment: 1,
	Requisition: 2,
}

export const ContactResult = {
	Success: 1,
	Postponed: 2,
	Refused: 3,
	NotAnswered: 4,
	NotApplicable: 5,
}

export const RequisitionType = {
	Appointment: 1,
	Imagiology: 2,
	ClinicalAnalysis: 3,
	Physiotherapy: 4,
	Surgery: 5,
	NonSurgical: 6,
	OtherMCDTs: 7,
	Dentist: 8,
	Nursing: 9,
	PathologicAnatomy: 10,
	Medication: 11,
	Relapse: 12,
	Transfer: 13,
}

export const InjuredState = {
	Validation: 1,
	Analysis: 2,
	Accepted: 3,
	Refused: 4,
	Terminated: 5,
	Reopened: 6,
	Canceled: 7,
	AdministrativelyReopened: 8,
	withoutAssistance: 9,
	OutOfNetworkDischarge: 10,
	TreatmentOutsideNetwork: 11,
	InsuranceNetwork: 12,
	NoContact: 13,
	withoutResponseOnContact: 14,
	UnderConsideration: 17,
	Closed: 18,
	AcceptedPending: 19,
	AcceptedForward: 20,
}

export const InsuranceEntity = {
	Caravela: 249,
	VictoriaVida: 29331,
	AVUS: 32003,
	LibertyIntegração: 32024,
	Liberty: 32015,
	MapfreSeguros: 32202,
	AON: 32203,
	Segurmet: 32354,
	CASeguros: 32355,
	GJM: 32381,
	ParticularesDesportivos: 32409,
	Ageas: 32048,
	Ocidental: 32204,
	Zurich: 248,
	Allianz: 32493,
}

export const ManagementType = {
	OccupationalMedicine: 'MT',
	Provider: 'PRE',
	InsuranceCompany: 'SEG',
	Trust: 'TRT',
}

export const Segment = {
	SportsAccident: 'AD',
	WorkRelated: 'AT',
	TrafficAccident: 'AV',
}

export const Provider = {
	PortoHSM: 14779,
	LisboaSAMS: 14764,
}

export const CoordinatorType = {
	InitialCoordinator: 'InitialCoordinator',
	ClinicalCoordinator: 'ClinicalCoordinator',
	FinalSituationPrevisionCoordinator: 'FinalPrevisionCoordinator',
	AdministrativeManager: 'AdministrativeCoordinator',
}

export const AppointmentStatus = {
	Scheduled: 5,
	Executed: 6,
	Approved: 9,
	MissedPatient: 7,
	MissedDoctor: 8,
	Nullified: 10,
	Rescheduled: 12,
}

export const AppointmentPendingStatus = {
	Marcada: 'Marcada',
	AguardaAprovaçãoClínica: 'AguardaAprovaçãoClínica',
	AguardaAprovaçãoAdministrativa: 'AguardaAprovaçãoAdministrativa',
	Aprovada: 'Aprovada',
}

export const RequisitionStatus = {
	Requested: 1,
	WaitingApproval: 2,
	ClinicallyApproved: 3,
	Executed: 4,
	AdministrativeApprove: 6,
	ClinicallyRefused: 8,
	PartiallyApproved: 9,
	AcceptedByProvider: 10,
	OnGoing: 17,
	PendingExecution: 18,
	WaitingForSchedule: 19,
}

export const SuggestType = {
	Imaging: 1,
	Physiotherapy: 2,
	ProcessForwarding: 3,
}

export const MedicalActId = {
	PhysiotherapyMedicalActId: 7041,
}

export const NotificationType = {
	AcutePhase: 148,
}

export const ClinicalStatus = {
	Pending: 'ON_HOLD',
	OnGoing: 'ON_GOING',
	Discharged: 'EXECUTED',
}

export const TaskType = {
	ProcessProviderForwarding: 'ProcessProviderForwarding',
	TransferOpinion: 'TransferOpinion',
}
